import React from 'react';
import ProductGrid from '../../ProductSearch/components/ProductGrid';

/**
 * RecoProductsGrid
 * Temporary grid to show recommended products when main search results are not yet loaded
 */
const RecoProductsGrid = ({
  products = [],
  hasScrolled,
  setHasScrolled,
  currentQuery = '',
  clientKey,
  currencyCode,
  roundingEnabled
}) => {
  if (!Array.isArray(products) || products.length === 0) {
    return null;
  }

  return (
    <div className="bg-[#F9F9F9]">
      <div className="mb-3 text-sm font-medium text-gray-800 px-1">Personalised picks</div>
      <ProductGrid
        products={products}
        hasScrolled={hasScrolled}
        setHasScrolled={setHasScrolled}
        currentQuery={currentQuery}
        clientKey={clientKey}
        currencyCode={currencyCode}
        roundingEnabled={roundingEnabled}
        isRecoProductsGrid={true}
      />
    </div>
  );
};

export default RecoProductsGrid;
